// Quirinoli - Regalo di benvenuto (Cavatappi)
// Se l'URL contiene ?welcome_gift=1, aggiunge automaticamente il Cavatappi
// al carrello e apre il drawer del carrello, senza cambiare pagina.

(function () {
  const CORKSCREW_VARIANT_ID = 54683509653850; // aggiorna qui se il Variant ID cambia in futuro

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  async function addWelcomeGift() {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: CORKSCREW_VARIANT_ID, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        console.error('Quirinoli welcome gift: aggiunta al carrello fallita', await response.text());
        return;
      }

      const addedItem = await response.json();

      // Recupera lo stato completo del carrello (serve al tema per aggiornare l'icona/drawer)
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // Stesso evento che il tema usa per la sua normale animazione "aggiungi al carrello":
      // lo ricreiamo manualmente cos\u00ec il drawer si apre esattamente come sempre.
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'welcome-gift-script',
            data: {
              source: 'welcome-gift',
              productId: addedItem.product_id,
              variantId: String(CORKSCREW_VARIANT_ID),
              itemCount: cart.item_count,
            },
          },
        })
      );

      // Rimuove il parametro dall'URL, cos\u00ec ricaricando la pagina non si aggiunge di nuovo
      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('welcome_gift');
      window.history.replaceState({}, '', cleanUrl.toString());
    } catch (err) {
      console.error('Quirinoli welcome gift: errore', err);
    }
  }

  if (getUrlParam('welcome_gift') === '1') {
    // Aspetta che la pagina (e il componente drawer) siano pronti prima di scattare
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addWelcomeGift);
    } else {
      addWelcomeGift();
    }
  }
})();